import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { TextField, Button } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import {
  authHandlingErrors,
  fogotPasswordAction
} from "../../../../redux/actions/auth";
import { withRouter } from "react-router-dom";
import style from "./Common.module.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    marginBottom: "26px"
  }
}));

const ForgotContent = ({
  backToLogin,
  authHandlingErrors,
  fogotPasswordAction,
  errors,
  closeModal
}) => {
  const classes = useStyles();

  const [email, setEmail] = useState("");

  useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        fogotPasswordHandler();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, errors]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      authHandlingErrors({});
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = event => {
    if (errors && errors.email) {
      authHandlingErrors({});
    }
    const { value } = event.target;
    setEmail(value);
  };

  const fogotPasswordHandler = () => {
    const data = {
      email
    };
    fogotPasswordAction(data, redirectHandler);
  };

  const redirectHandler = () => {
    closeModal();
    toast.success(`We have e-mailed your password reset link!`);
  };

  return (
    <>
      <div className={style.wrapper}>
        <TextField
          error={errors && errors.email ? true : false}
          className={classes.root}
          label="Email Address"
          variant="outlined"
          onChange={handleChange}
          helperText={errors && errors.email ? errors.email : ""}
        />
      </div>
      <div className={style.btnGroup}>
        <Button onClick={backToLogin}>back to login</Button>
        <Button onClick={fogotPasswordHandler}>send</Button>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    errors: state.auth.errors
  };
};

const mapDispatchToProps = { authHandlingErrors, fogotPasswordAction };

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ForgotContent)
);
